import retailerOrdersPath from "@faire/web-api/routes/user/account/orders";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Dropdown } from "@faire/web/slate/Input/Dropdown";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useLoggedOutIssuesDropdown } from "../hooks/useLoggedOutIssuesDropdown";
export var DropdownGroups = function DropdownGroups() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useLoggedOutIssuesDr = useLoggedOutIssuesDropdown(),
    issueL1 = _useLoggedOutIssuesDr.issueL1,
    issueL2 = _useLoggedOutIssuesDr.issueL2,
    issueL3 = _useLoggedOutIssuesDr.issueL3,
    showDropdownL2 = _useLoggedOutIssuesDr.showDropdownL2,
    showDropdownL3 = _useLoggedOutIssuesDr.showDropdownL3,
    handleSelectL1 = _useLoggedOutIssuesDr.handleSelectL1,
    handleSelectL2 = _useLoggedOutIssuesDr.handleSelectL2,
    handleSelectL3 = _useLoggedOutIssuesDr.handleSelectL3,
    issuesFromL1 = _useLoggedOutIssuesDr.issuesFromL1,
    issuesFromL2 = _useLoggedOutIssuesDr.issuesFromL2,
    issuesFromL3 = _useLoggedOutIssuesDr.issuesFromL3,
    showGoToOrderPageCopy = _useLoggedOutIssuesDr.showGoToOrderPageCopy;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledDropdown, {
    value: issueL1,
    options: issuesFromL1,
    onSelect: handleSelectL1,
    placeholder: strictLocalize({
      id: "Crmf/c",
      defaultMessage: "Select a topic"
    }),
    "data-test-id": "select-a-topic-dropdown"
  }), showGoToOrderPageCopy ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "TJBkES",
    defaultMessage: [{
      "type": 0,
      "value": "To report items or packages as missing or damaged, please go to the Orders page within your "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire portal"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: LinkToRetailerOrders
    }
  })))) : null, showDropdownL2() ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(StyledDropdown, {
    value: issueL2,
    options: issuesFromL2,
    onSelect: handleSelectL2,
    placeholder: strictLocalize({
      id: "7kARMU",
      defaultMessage: "Select an issue type"
    }),
    "data-test-id": "select-an-issue-type-dropdown"
  }))) : null, showDropdownL3() ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(StyledDropdown, {
    value: issueL3,
    options: issuesFromL3(),
    onSelect: handleSelectL3,
    placeholder: strictLocalize({
      id: "bPAmAM",
      defaultMessage: "Choose a category"
    }),
    "data-test-id": "choose-a-category-dropdown"
  }))) : null);
};
var LinkToRetailerOrders = function LinkToRetailerOrders(chunk) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: retailerOrdersPath(),
    target: "__blank"
  }, chunk);
};
var StyledDropdown = styled(Dropdown).withConfig({
  displayName: "DropdownGroups__StyledDropdown"
})(["width:100%;"]);